import { OwnUpSmallBody } from '@rategravity/own-up-component-library';
import React from 'react';
import { WidgetWrapper } from '../common/WidgetWrapper';
import { CalculatorProvider } from './data/dataProvider';
import { Inputs } from './inputs';
import { CalculationSummary } from './summary';

const description = (
  <React.Fragment>
    <OwnUpSmallBody variant="body1">
      A home affordability calculator is a great place to start your home buying journey.
    </OwnUpSmallBody>
    <br />
    <OwnUpSmallBody variant="body1">
      This tool calculates how much home you can reasonably afford based on a lender’s qualification
      for pre-approval.{' '}
    </OwnUpSmallBody>
  </React.Fragment>
);

export const AffordabilityCalculator: React.FC = () => {
  return (
    <WidgetWrapper title="Affordability Calculator" description={description}>
      <CalculatorProvider>
        <Inputs />
        <CalculationSummary />
      </CalculatorProvider>
    </WidgetWrapper>
  );
};
